import { createFileRoute } from '@tanstack/react-router';
import { isPermissionParcialOrFull } from '@/features/login/util/permission';
import { validateRoute } from '@/router/util';

export const Route = createFileRoute('/a/transportador')({
    beforeLoad: () =>
        validateRoute({
            fintech: false,
            validatePermission: ({ upp_cadastro_transportadora }) =>
                isPermissionParcialOrFull(upp_cadastro_transportadora),
        }),
});
